// src/hooks/useModelThumbnail.js
import { useEffect, useState } from 'react';
import axios from 'axios';
import { getModelThumbnailUrl } from '../api/modelService';

/**
 * Image URL for a model's thumbnail. Approved models load it directly; for pending or
 * rejected models (visible only to the uploader and admins) the image is fetched with
 * the login token, since a plain <img> request cannot send it.
 */
const useModelThumbnail = (model) => {
  const [src, setSrc] = useState(null);
  const id = model?.id;
  const hasThumbnail = Boolean(model?.has_thumbnail);
  const isPublic = model?.status === 'approved';

  useEffect(() => {
    if (!id || !hasThumbnail) {
      setSrc(null);
      return undefined;
    }
    if (isPublic) {
      setSrc(getModelThumbnailUrl(id));
      return undefined;
    }

    let objectUrl = null;
    let cancelled = false;
    axios.get(getModelThumbnailUrl(id), { responseType: 'blob' })
      .then((response) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(response.data);
        setSrc(objectUrl);
      })
      .catch(() => !cancelled && setSrc(null));

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [id, hasThumbnail, isPublic]);

  return src;
};

export default useModelThumbnail;
